<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="30" height="30" fill="white" fill-opacity="0.01"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25 6.25C5.91848 6.25 5.60054 6.3817 5.36612 6.61612C5.1317 6.85054 5 7.16848 5 7.5V8.75H25V7.5C25 7.16848 24.8683 6.85054 24.6339 6.61612C24.3995 6.3817 24.0815 6.25 23.75 6.25H6.25ZM20.1875 25H9.80625C9.51055 24.9999 9.22445 24.895 8.9988 24.7039C8.77314 24.5128 8.62254 24.2479 8.57375 23.9563L6.25 10H23.75L21.42 23.9575C21.3712 24.249 21.2205 24.5138 20.9948 24.7047C20.7692 24.8956 20.4831 25.0002 20.1875 25ZM11.25 5.625C11.25 5.46117 11.3143 5.30388 11.4291 5.18699C11.5439 5.0701 11.6999 5.00295 11.8638 5H18.1362C18.3001 5.00295 18.4561 5.0701 18.5709 5.18699C18.6857 5.30388 18.75 5.46117 18.75 5.625V6.25H11.25V5.625Z" fill="#FF5C41"/>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
